<div class="modal inmodal fade in parcel-modal create-modal" [ngClass]="{'show': showModal}">
    <form #form="ngForm" submittable autocomplete="off">
        <div class="modal-dialog ">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title col-sm-8">New Service Request</h4>
                    <button type="button" class="close" (click)="hideModal()">
                        <span>×</span><span class="sr-only">Close</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="row m-b-sm step-guide">
                        <div (click)="moveToTheNextStep('buildingInfo')" class="mtv-primary-color">
                            <span *ngIf="authService.userIsResident">Details</span>
                            <span *ngIf="!authService.userIsResident">Building Info</span>
                        </div>
                        <div (click)="moveToTheNextStep('generalInfo')"
                             [ngClass]="{'mtv-primary-color': (step == 'generalInfo' || step == 'notes' || step == 'summary')}">
                            <span>General Info</span>
                        </div>
                        <div (click)="moveToTheNextStep('notes')"
                             [ngClass]="{'mtv-primary-color': (step == 'notes' || step == 'summary')}">
                            <span>Notes</span>
                        </div>
                        <div (click)="moveToTheNextStep('summary')"
                             [ngClass]="{'mtv-primary-color': step == 'summary'}">
                            <span>Summary</span>
                        </div>
                    </div>
                    <div class="row m-b-md step-progress-bar">
                        <div class="col-sm-3" [ngStyle]="{ 'width': calculateCurrentProgressBarLength() }"></div>
                    </div>
                    <div *ngIf="step == 'buildingInfo'">
                        <!-- ___ Building ___ -->
                        <div class="row m-b-sm"
                             [ngStyle]="{'display': authService.userIsResident || serviceRequestService.buildingsForUpdate.length < 2 ? 'none':'block'}">
                            <div class="col-md-4">
                                <label>Building</label>
                            </div>
                            <div class="col-md-8">
                                <select class="form-control"
                                        name="buildingId"
                                        [(ngModel)]="data.buildingId"
                                        required
                                        [disabled]="serviceRequestService.modalSpinnerShow || buildingSelectIsDisabled"
                                        (change)="changeBuilding($event.target.value)"
                                        #buildingSelect>
                                    <option value="" hidden></option>
                                    <option *ngFor="let build of serviceRequestService.buildingsForUpdate"
                                            [value]="build.id">
                                        {{build.name}}
                                    </option>
                                </select>
                            </div>
                        </div>

                        <!-- ___ Unit ___ -->
                        <div [ngStyle]="{'display': authService.userIsResident? 'none':'block'}" class="row m-b-sm">
                            <div class="col-md-4">
                                <label>Unit</label>
                            </div>
                            <div class="col-md-8 fourteenPixelText">
                                <search-select [(ngModel)]="data.suiteId"
                                               name="suiteId" #suiteSelect
                                               [disabled]="serviceRequestService.modalSpinnerShow"
                                               (ngModelChange)="changeUnit($event)"
                                               [data]="suiteToSearchSelect(suites)"
                                               required>
                                </search-select>
                                <input *ngIf="suiteSelect.value == '0'"
                                       class="form-control"
                                       [disabled]="serviceRequestService.modalSpinnerShow"
                                       [(ngModel)]="data.suiteNumber"
                                       name="otherSuite"
                                       placeholder="Other Unit Number"
                                       maxlength="255" required>
                                <spinner [spinnerShow]="buildingSelect.value &&
                                                        buildingSelect.value != 'null' &&
                                                        !suites.length">
                                </spinner>
                            </div>
                        </div>

                        <!-- ___ Resident ___ -->
                        <div [ngStyle]="{'display': authService.userIsResident? 'none':'block'}" class="row m-b-sm">
                            <div class="col-md-4">
                                <label>Resident</label>
                            </div>
                            <div class="col-md-8">
                                <select class="form-control"
                                        [(ngModel)]="data.residentId"
                                        name="residentId"
                                        #residentSelect
                                        [disabled]="serviceRequestService.modalSpinnerShow"
                                        (change)="changeResident($event.target.value)"
                                        [disabled]="!residents.length" required>
                                    <option value="" hidden></option>
                                    <option *ngFor="let resident of residents" [value]="resident.id">
                                        {{resident.fullName}}
                                    </option>
                                </select>
                                <input *ngIf="suiteSelect.value == '0' || residentSelect.value == '0'"
                                       class="form-control"
                                       [disabled]="serviceRequestService.modalSpinnerShow"
                                       placeholder="Other Resident Name"
                                       [(ngModel)]="data.otherResident"
                                       name="otherResident"
                                       maxlength="255" required>
                                <spinner [spinnerShow]="suiteSelect.value &&
                                                        suiteSelect.value != 'null' &&
                                                        !residents.length">
                                </spinner>
                            </div>
                        </div>

                        <div class="row m-b-sm">
                            <div class="col-md-8">
                                <label>Grant Permission To Enter The Unit</label>
                            </div>
                            <div class="col-md-4">
                                <select class="form-control"
                                        name="permissionToEnter"
                                        [disabled]="(serviceRequestService.modalSpinnerShow && !authService.userIsResident)"
                                        [(ngModel)]="data.permissionToEnter" required>
                                    <option [ngValue]="true">Yes</option>
                                    <option [ngValue]="false">No</option>
                                </select>
                            </div>
                        </div>

                        <div class="row text-center space-30">
                            <button class="btn btn-primary submit-btn"
                                    type="submit"
                                    (click)="moveToTheNextStep('generalInfo')">
                                Continue
                            </button>
                        </div>
                    </div>

                    <div *ngIf="step == 'generalInfo'">
                        <!--___ Priority ___ -->
                        <div class="row m-b-sm">
                            <div class="col-md-4">
                                <label>Priority</label>
                            </div>
                            <div class="col-md-8">
                                <select class="form-control"
                                        name="serviceRequestPriority"
                                        [(ngModel)]="data.priority"
                                        [disabled]="serviceRequestService.modalSpinnerShow"
                                        required #serviceRequestPriority>
                                    <option value="" hidden></option>
                                    <option *ngFor="let priority of requestPriorities" [value]="priority.name">
                                        {{priority.displayName}}
                                    </option>
                                </select>
                            </div>
                        </div>

                        <!--___ Type ___ -->
                        <div class="row m-b-sm">
                            <div class="col-md-4">
                                <label>Type</label>
                            </div>
                            <div class="col-md-8">
                                <select class="form-control"
                                        name="serviceRequestType"
                                        [(ngModel)]="data.serviceRequestType"
                                        [disabled]="serviceRequestService.modalSpinnerShow"
                                        #serviceRequestType required>
                                    <option value="" hidden></option>
                                    <option *ngFor="let type of requestTypes" [value]="type.id">{{type.name}}</option>
                                </select>
                                <input *ngIf="serviceRequestType.value == '0'"
                                       class="form-control"
                                       [disabled]="serviceRequestService.modalSpinnerShow"
                                       [(ngModel)]="data.serviceRequestTypeOther"
                                       name="serviceRequestTypeOther"
                                       placeholder="Other Request Type"
                                       maxlength="255" required>
                            </div>
                        </div>

                        <!-- ___ Description  ___ -->
                        <div class="row m-b-sm">
                            <div class="col-md-4">
                                <label>Description</label>
                            </div>
                            <div class="col-md-8">
                                <textarea class="form-control"
                                          [disabled]="serviceRequestService.modalSpinnerShow"
                                          name="description"
                                          [(ngModel)]="data.description">
                                </textarea>
                            </div>
                        </div>

                        <div class="row text-center space-30">
                            <button class="btn btn-primary submit-btn" type="submit" (click)="moveToTheNextStep('notes')">
                                Continue
                            </button>
                        </div>
                    </div>

                    <div *ngIf="step == 'notes'">
                        <!-- ___ Notes  ___ -->
                        <div class="row m-b-sm">
                            <div class="col-md-4">
                                <label>Notes</label>
                            </div>
                            <div class="col-md-8">
                                <textarea class="form-control"
                                          [disabled]="serviceRequestService.modalSpinnerShow"
                                          name="notes"
                                          [(ngModel)]="data.notes">
                                </textarea>
                            </div>
                        </div>

                        <!-- ___ Images  ___ -->
                        <div class="row m-b-sm" *ngIf="serviceRequestService.residentAccessController(action.requestAttachment)">
                            <div class="col-xs-4 col-md-4">
                                <label>Images</label>
                            </div>
                            <div class="col-xs-8 col-md-8">
                                <input type="file"
                                       name="attachment"
                                       accept=".gif, .jpeg, .png, .jpg, .bmp, .pcx, .tiff"
                                       id="add-attachment-button"
                                       (change)="addFile($event)"
                                       hidden
                                       [disabled]="disabledFileInput">
                                <label for="add-attachment-button" class="btn mtv-primary-color">Add Image</label>
                            </div>
                        </div>
                        <ul class="attachment-box"
                            *ngIf="serviceRequestService.residentAccessController(action.requestAttachment)">
                            <li *ngFor="let item of attachments; let i = index;">
                                <a (click)="serviceRequestService.showAttachment(item)">
                                    <div>
                                        <span class="file-name">{{item.name}}</span>
                                    </div>
                                </a>
                                <i class="fa fa-trash" (click)="removeFile(i)" title="Delete Attachment"></i>
                            </li>
                        </ul>

                        <div class="row text-center space-30">
                            <button class="btn btn-primary submit-btn" type="submit" (click)="moveToTheNextStep('summary')">
                                Continue
                            </button>
                        </div>
                    </div>

                    <div *ngIf="step == 'summary'">
                        <div class="row m-b-sm" *ngIf="!authService.userIsResident">
                            <div class="col-md-4">
                                <label>Building</label>
                            </div>
                            <div class="col-md-8">{{getBuildingNameById()}}</div>
                        </div>

                        <div class="row m-b-sm" *ngIf="!authService.userIsResident">
                            <div class="col-md-4">
                                <label>Unit</label>
                            </div>
                            <div class="col-md-8">{{getSuiteNameById()}}</div>
                        </div>

                        <div class="row m-b-sm" *ngIf="!authService.userIsResident">
                            <div class="col-md-4">
                                <label>Resident</label>
                            </div>
                            <div class="col-md-8">{{getResidentNameById()}}</div>
                        </div>

                        <div class="row m-b-sm">
                            <div class="col-md-4">
                                <label>Priority</label>
                            </div>
                            <div class="col-md-8">{{getRequestPriorityName()}}</div>
                        </div>

                        <div class="row m-b-sm">
                            <div class="col-md-4">
                                <label>Type</label>
                            </div>
                            <div class="col-md-8">{{getRequestTypeName()}}</div>
                        </div>

                        <div class="row m-b-sm">
                            <div class="col-md-4">
                                <label>Permissions to Enter</label>
                            </div>
                            <div class="col-md-8">
                                <i *ngIf="data.permissionToEnter" class="icon-check"></i>
                                <i *ngIf="!data.permissionToEnter" class="icon-close"></i>
                            </div>
                        </div>

                        <div class="row m-b-sm" *ngIf="data.description">
                            <div class="col-md-4">
                                <label>Description</label>
                            </div>
                            <div class="col-md-8">
                                <pre>{{data.description}}</pre>
                            </div>
                        </div>

                        <div class="row m-b-sm" *ngIf="data.notes">
                            <div class="col-md-4">
                                <label>Notes</label>
                            </div>
                            <div class="col-md-8">
                                <pre>{{data.notes}}</pre>
                            </div>
                        </div>

                        <div class="row text-center space-30">
                            <button class="btn btn-primary submit-btn"
                                    type="submit"
                                    (click)="onSubmit(form)"
                                    [disabled]="disabledSubmit">
                                Save
                            </button>
                        </div>
                    </div>
                    <spinner [spinnerShow]="serviceRequestService.modalSpinnerShow"></spinner>
                </div>
            </div>
        </div>
    </form>
    <div class="modal-backdrop fade in" (click)="hideModal()"></div>
</div>
<view-attachment-modal *ngIf="serviceRequestService.es.isViewAttachmentModalShow"></view-attachment-modal>



// WEBPACK FOOTER //
// /app/src/app/views/service-request/service-request-modal/service-request-modal.component.html